import type { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	type SfaaClassExperienceSeriesQuery,
	sfaaClassExperienceSeriesQueryKey,
} from "../sfaa-class-experience.keys";

export const buildSfaaClassExperienceSeriesSearchParams = (
	query: SfaaClassExperienceSeriesQuery,
): string => {
	const params = new URLSearchParams();
	if (query.line !== undefined) params.append("line", query.line);
	if (query.subline !== undefined) params.append("subline", query.subline);
	if (query.codeSeries !== undefined) params.append("codeSeries", query.codeSeries);
	if (query.sfaaCode !== undefined) params.append("sfaaCode", query.sfaaCode);
	params.append("location", query.location);
	params.append("comparison", query.comparison);
	return params.toString();
};

/** Uses server aggregation because each line spans more rows than the row endpoint can return. */
export const useFetchSfaaClassExperienceSeries = (query: SfaaClassExperienceSeriesQuery) => {
	const { get } = useRequest();

	return useQuery({
		queryKey: sfaaClassExperienceSeriesQueryKey(query),
		queryFn: async () =>
			await get<Dtos.Admin.SfaaClassExperience.Series.Response>(
				`/v2/admin/surety/sfaa-class-experience/series?${buildSfaaClassExperienceSeriesSearchParams(query)}`,
			),
	});
};
